import React, { FC } from "react";
import { RestrictedWidthContainer } from "../../DialogComponents/styled";
import { AddProxyServiceWizardStep } from "./AddProxyServiceWizardStep";
import { ProxyServiceMeta } from "./ProxyServiceMeta";

export const AddProxyServiceMeta: FC = () => (
  <AddProxyServiceWizardStep>
    <RestrictedWidthContainer>
      <ProxyServiceMeta showSystemName />
    </RestrictedWidthContainer>
  </AddProxyServiceWizardStep>
);
